import client from '@/utils/httpClient';
import { useQuery } from 'react-query';
import { VirtualConferenceDashboardKeys } from './virtualConferenceDashboard.keys';

export interface VirtualConferenceOrganization {
  id: string;
  name: string;
}

function getVirtualConferenceOrganizations() {
  return client
    .get<VirtualConferenceOrganization[]>('/virtualconferencedashboard/organizations')
    .then((response) => response.data);
}

export function useGetVirtualConferenceOrganizations() {
  return useQuery(
    VirtualConferenceDashboardKeys.organizations(),
    getVirtualConferenceOrganizations,
    {
      staleTime: 5 * 60 * 1000,
    },
  );
}
